import React from 'react';
import { LuCheck, LuCircleX, LuInfo, LuTriangleAlert } from 'react-icons/lu';
import { StyledIcon } from './AlertIcon.styles';

function AlertIcon({ $type }) {
  const iconType = () => {
    switch ($type) {
      case 'error':
        return <LuCircleX />;
      case 'info':
        return <LuInfo />;
      case 'warning':
        return <LuTriangleAlert />;
      case 'success':
        return <LuCheck />;
      default:
        return <LuInfo />;
    }
  };
  return (
    <>
      <StyledIcon $type={$type}>
        <span className="material-icons-outlined">{iconType()}</span>
      </StyledIcon>
    </>
  );
}

export default AlertIcon;
